export const tabIndex = (focusable = true) => (focusable ? 0 : -1);
